/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { TestimonialData } from "../../Data/Data";
const Testimonial = () => {
  return (
    <div className="p-o m-0 box-border bg-[#01091A] py-16">
      <div className="w-[90%] mx-auto font-Urbanist ">
        <h2 className="font-semibold text-4xl text-background pt-5 pb-2 text-center">
          Testimonials
        </h2>
        <p className="font-medium text-white text-2xl pb-8 text-center">
          What Client Says
        </p>
        <div className="flex flex-col lg:flex-row justify-between gap-8 md:gap-4 items-center">
          {TestimonialData?.map((item) => (
            <div
              key={item.id}
              className=" w-[320px] sm:w-[350px] h-[250px] mb-16 rounded-md border shadow-xl"
            >
              <div className=" w-[290px] sm:w-[300px] h-full mx-auto text-white">
                <FaQuoteLeft className="text-4xl my-6 ml-3 text-red" />
                <p className="font-medium pl-3">{item.title}</p>
                <p className="py-4 font-medium pl-3">{item.name}</p>
                <p></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
